import { render, staticRenderFns } from "./LoanDocumentsTab.vue?vue&type=template&id=231d7d99&scoped=true"
import script from "./LoanDocumentsTab.vue?vue&type=script&lang=js"
export * from "./LoanDocumentsTab.vue?vue&type=script&lang=js"
import style0 from "./LoanDocumentsTab.vue?vue&type=style&index=0&id=231d7d99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231d7d99",
  null
  
)

export default component.exports